/// <amd-module name="Search/Shared/Base/Stores/SettingsStore" />
import { ISearchLocalSettingsService, Scope } from "Search/Shared/Base/LocalSettingsService";
import { IVssPageContext } from "VSS/Platform/Context";
import { Store } from "VSS/Reflux/Store";

export class SettingsStore<T> extends Store {
    constructor(
        changedEventName: string,
        private settingKey: string,
        protected pageContext: IVssPageContext) {
        super(changedEventName);
    }

    protected readSetting = (defaultValue: T, scope?: Scope): T => {
        const localSettingsService = this.pageContext.getService<ISearchLocalSettingsService>("ISearchLocalSettingsService");
        const value: T = localSettingsService.getValue<T>(this.settingKey, defaultValue, scope);

        return value;
    }

    protected writeSetting = (value: T, scope?: Scope): void => {
        const localSettingsService = this.pageContext.getService<ISearchLocalSettingsService>("ISearchLocalSettingsService");
        localSettingsService.setValue(this.settingKey, value, scope);
    }
}